/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Immature_DetrainingInputs */

const en_coach_immature_detraining = /** @type {(inputs: Coach_Immature_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness metrics are still stabilizing (less than 4 weeks of data). Current readings suggest training has been light recently. Focus on building consistency — the numbers will become more reliable as your history grows.`)
};

const de_coach_immature_detraining = /** @type {(inputs: Coach_Immature_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte pendeln sich noch ein — weniger als 4 Wochen Daten. Aktuell sieht es nach wenig Training aus. Bleib dran und trainiere regelmäßig — die Werte werden mit der Zeit aussagekräftiger.`)
};

/**
* | output |
* | --- |
* | "Your fitness metrics are still stabilizing (less than 4 weeks of data). Current readings suggest training has been light recently. Focus on building consiste..." |
*
* @param {Coach_Immature_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_immature_detraining = /** @type {((inputs?: Coach_Immature_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Immature_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_immature_detraining(inputs)
	return de_coach_immature_detraining(inputs)
});